// This file is auto-generated by the `update-kc-gen` command. Do not edit it manually.
// Hash: 7bd755dd42720b11300314302182741ed96912144c356fc5602089859061ff99

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

import { lazy, Suspense, type ReactNode } from "react";

export type ThemeName = "vetifier";

export const themeNames: ThemeName[] = ["vetifier"];

export type KcEnvName = never;

export const kcEnvNames: KcEnvName[] = [];

export const kcEnvDefaults: Record<KcEnvName, string> = {};

/**
 * NOTE: Do not import this type except maybe in your entrypoint.
 * If you need to import the KcContext import it either from src/login/KcContext.ts or src/account/KcContext.ts.
 * Depending on the theme type you are working on.
 */
export type KcContext = import("./login/KcContext").KcContext;

declare global {
    interface Window {
        kcContext?: KcContext;
    }
}

export const KcLoginPage = lazy(() => import("./login/KcPage"));

export function KcPage(props: { kcContext: KcContext; fallback?: ReactNode }) {
    const { kcContext, fallback } = props;
    return (
        <Suspense fallback={fallback}>
            {(() => {
                switch (kcContext.themeType) {
                    case "login":
                        return <KcLoginPage kcContext={kcContext} />;
                }
            })()}
        </Suspense>
    );
}

// NOTE: This is a polyfill for `import.meta.env.BASE_URL` as it's not available in Webpack environment.
export const BASE_URL =
    window.kcContext === undefined || process.env.NODE_ENV === "development"
        ? process.env.PUBLIC_URL === ""
            ? "/"
            : `undefined/`
        : `${kcContext["x-keycloakify"].resourcesPath}/dist/`;

// NOTE: This is only exported here because you're supposed to import type from different packages
// Depending of if you are using Vite, Webpack, ect...
export type { Meta, StoryObj } from "@storybook/react-webpack5";
